import React from "react";
import { Message } from "semantic-ui-react";
import { textInputRender } from "../../utils/components";
import { validateEmailString } from "../../utils/formValidation";
import { blankHref } from "../../utils/utils";
import FormModal from "../common/FormModal";

type PasswordResetFormModalProps = {
  onSubmit: (values: any) => void;
};

class PasswordResetFormModal extends React.PureComponent<PasswordResetFormModalProps> {
  render() {
    return (
      <FormModal
        size="mini"
        modalHeader="Reset password"
        preFormContent={
          <Message info>
            An email to reset your password will be sent to this email address.
          </Message>
        }
        fields={[
          {
            name: "email",
            render: textInputRender("Email", "Type in your email", true),
            validators: [validateEmailString],
            required: true
          }
        ]}
        onSubmit={this.props.onSubmit}
        modalTrigger={onClick => (
          <div className="field">
            <a href={blankHref} onClick={onClick}>
              Forgot password?
            </a>
          </div>
        )}
      />
    );
  }
}
export default PasswordResetFormModal;
